import { render, staticRenderFns } from "./EditUrlPopup.vue?vue&type=template&id=2abbeb8c&scoped=true"
import script from "./EditUrlPopup.vue?vue&type=script&lang=js"
export * from "./EditUrlPopup.vue?vue&type=script&lang=js"
import style0 from "./EditUrlPopup.vue?vue&type=style&index=0&id=2abbeb8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abbeb8c",
  null
  
)

export default component.exports